import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { usePlanesMutations } from '../../hooks'
import { ButtonSubmit, FooterPages } from '..';

const initialState = {
empresa:'',
codigo: '',
nombrePlan: '',
tipoPlan: 'Retiro',
valor: '',
descripcion: '',
estado: 'Activo',
};

const NuevoPlan = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addPlan, updatePlanC } = usePlanesMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(vecinoData) setFormData(vecinoData);
  }, [vecinoData]);


  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones

    if(!vecinoData._id) 
    {
      // console.log('crear VECINO');
       await addPlan.mutateAsync( formData );
    } else
    { 
       await updatePlanC.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevoequipo );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
    <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">
          
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nuevo" : "Editar"} Plan Suscripción
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevoequipo)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          
          <div className="mt-5 space-y-4">
          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4" >

                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Código</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="codigo"
                      value= {formData.codigo}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Plan</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="nombrePlan"
                        value= {formData.nombrePlan}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>
                <div className="col-span-2">
                  < div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Tipo</label>
                    <select className={inputClass} name="estado" value= {formData.tipoPlan} required onChange={handleChange}>
                      <option value="Retiro">Retiro en Domicilio</option>
                      <option value="Entrega">Entrega en Punto Drop off</option>
                    </select>
                  </div>
                </div>  
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Valor</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="valor"
                      value= {formData.valor}
                      required
                      onChange={handleChange}
                    />
                </div>
              </div>


              <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >

                <div className="col-span-3">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Descripción</label>
                    <textarea
                        className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300 h-48 max-h-96"
                        type="text"
                        placeholder=""
                        name="descripcion"
                        value= {formData.descripcion}
                        onChange={handleChange}
                      />
                  </div>
                </div>
                < div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Estado</label>
                      <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                        <option value="ACTIVO">Activo</option>
                        <option value="INACTIVO">Inactivo</option>
                        <option value="ELIMINADO">Eliminado</option>
                      </select>
                  </div>

              </div>

              </div>

              <div className="grid grid-cols-4 gap-4" >
                  <div className="flex flex-col">
                      <ButtonSubmit
                        color="white"
                        bgColor={currentColor}
                        text= { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}  
                        borderRadius="10px"
                        onClick = {handleSubmit}
                        width="full"
                      />   
                  </div>
              </div>           
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoPlan;